import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor"


export const getEncabezadoSales = async(dates) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/EncabezadoPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}
export const getDetallesSales = async(dates) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/DetallesPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}

export const obtenerNoOrden = async() =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/ObtenerNoOrden','GET')
    return result
}

export const getEncabezadoOrdenPorId = async(IdSalesOrderEnc) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/getEncabezadoOrdenPorID','POST', {IdSalesOrderEnc} )
    return result
}

export const getDetallesOrdenPorId = async(IdSalesOrderEnc) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/getDetallesOrdenPorID','POST', {IdSalesOrderEnc} )
    return result
}

export const getEncabezadoOrdenPorNo = async(NoOrden) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/getEncabezadoOrdenPorNo','POST', {NoOrden} )
    return result
}

export const getDetallesOrdenPorNo = async(NoOrden) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/getDetallesOrdenPorNo','POST', {NoOrden} )
    return result
}


export const GuardarOrdenVenta = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Ventas/SalesOrders/GuardarOrdenVenta", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const EditarOrdenVenta = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Ventas/SalesOrders/EditarOrdenVenta", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const LiberarOrdenVenta = async (IdSalesOrderEnc, IdUserEdit, status) => {
    const respuesta = PrivateInterceptor("Ventas/SalesOrders/LiberarOrdenVenta", "POST",{IdSalesOrderEnc, IdUserEdit, status});
    return respuesta;
};

export const EliminarOrdenVenta = async (IdSalesOrderEnc, IdUserEdit, status) => {
    const respuesta = PrivateInterceptor("Ventas/SalesOrders/EliminarOrdenVenta", "POST",{IdSalesOrderEnc, IdUserEdit, status});
    return respuesta;
};

export const EliminarOrdenVentaDet = async (IdSalesOrderDet, IdUserEdit, status) => {
    const respuesta = PrivateInterceptor("Ventas/SalesOrders/EliminarOrdenVentaDet", "POST",{IdSalesOrderDet, IdUserEdit, status});
    return respuesta;
};

